<template>
   <table-component-buefy
    v-if="mixin.loaded"
    :hide_table_search="true"
    :content="certificates"
    :headings="headings"
    :item_keys="item_keys"
    :display_spec="certificateSpecs"
    :total_items="mixin.total_items"
    :pagination_callback="mixin.loadItems"
    :col_styles="col_styles">
  </table-component-buefy>
  <!-- Loader -->
  <loader-component v-else></loader-component>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import TableComponentBuefy from '@/components/layout/table/TableComponentBuefy'
  import { certificateSpecs } from '@/display_context/display_context'
  import { loadItemsMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import LoaderComponent from '@/components/layout/utility/LoaderComponent'

  export default {
    name: 'certificate-list-view',
    mixins: [loadItemsMixin, setContainedHeightMixin],
    data () {
      return {
        headings: ['Certificate No.', 'Certification', 'State', 'Issued date', 'Expiry date ', 'Is Reported'],
        item_keys: ['certificateAdminLink', 'service.code', 'state', 'issueDate', 'expiryDate', 'isReported'],
        col_styles: { 'isReported': ['alignLeft'] },
        certificateSpecs: certificateSpecs,
        mixin: {
          actionMethod: this.getCertificates,
          actionParams: { customer: this.customerId }
        }
      }
    },
    props: {
      customerId: {
        required: true
      }
    },
    components: {
      TableComponentBuefy,
      LoaderComponent
    },
    computed: {
      ...mapState({
        certificates: state => state.certificateModule.certificates
      })
    },
    methods: {
      ...mapActions([
        'getCertificates'
      ])
    }
  }
</script>
